import {Component, OnInit, AfterViewInit, ViewChild, ElementRef, Input} from '@angular/core';
import {CardWebCardPositioning} from '../shared/CardWebListElement';
import {ColorFactory} from '../shared/color-factory';

@Component({
  selector: 'em-card-visualization',
  templateUrl: './card-visualization.component.html',
  styleUrls: ['./card-visualization.component.css']
})
export class CardVisualizationComponent implements OnInit, AfterViewInit {
  @Input() positionings: CardWebCardPositioning[];
  @ViewChild('canvasElement', { static: false }) canvas: ElementRef;

  scale = 11;
  rectWidth = 10;  // Width of the rectangle
  rectHeight = 16; // Height of the rectangle (higher than width to make the card taller)
  minX = 0;
  maxY = 0;
  canvasWidth = 0;
  canvasHeight = 0;
  offsetX = 0; // Offset for centering on X-axis
  offsetY = 0; // Offset for centering on Y-axis
  maxXCards = 20;
  maxYCards = 20;
  scaleFactor = 1;

  ngOnInit() {
    this.calculateBounds();
  }

  ngAfterViewInit() {
    const ctx = this.canvas.nativeElement.getContext('2d');
    this.canvas.nativeElement.width = this.canvasWidth;  // Set canvas width
    this.canvas.nativeElement.height = this.canvasHeight; // Set canvas height
    this.drawRectanglesWithShadow(ctx);
  }

  calculateBounds() {
    const xValues = this.positionings.map(c => c.posX);
    const yValues = this.positionings.map(c => c.posY);
    this.minX = Math.min(...xValues);
    this.maxY = Math.max(...yValues);

    // Calculate the aspect ratio to ensure cards fit within the canvas
    const xRange = Math.max(...xValues) - this.minX + 1;
    const yRange = this.maxY - Math.min(...yValues) + 1;

    const scaleXFactor = this.maxXCards / xRange;
    const scaleYFactor = this.maxYCards / yRange;
    this.scaleFactor = Math.min(scaleXFactor, scaleYFactor);

    // Calculate canvas size based on card layout while preserving aspect ratio
    // const aspectRatio = yRange / xRange;
    this.canvasWidth = 350;
    this.canvasHeight = 350; // containerWidth * aspectRatio; // Maintain the aspect ratio

    // Calculate the offsets to center the cards in the canvas
    this.offsetX = (this.canvasWidth - xRange * this.scale) / 2;
    this.offsetY = (this.canvasHeight + yRange * this.scale) / 2;
    this.offsetX = this.offsetX * 0.5;
    this.offsetY = this.offsetY * 1.0;
    this.offsetX = this.offsetX / this.scaleFactor;
    this.offsetY = this.offsetY / this.scaleFactor;

  }

  drawRectanglesWithShadow(ctx: CanvasRenderingContext2D) {
    ctx.clearRect(0, 0, this.canvas.nativeElement.width, this.canvas.nativeElement.height); // Clear canvas before drawing

    // Set shadow properties
    ctx.shadowOffsetX = 2;
    ctx.shadowOffsetY = 2;
    ctx.shadowBlur = 3;
    ctx.shadowColor = 'rgba(0, 0, 0, 0.3)';
    ctx.scale(this.scaleFactor, this.scaleFactor);

    // Loop through the data.cards array to draw each card
    this.positionings.forEach(card => {
      const x = (card.posX - this.minX) * this.scale + this.offsetX;
      const y = (this.maxY - card.posY) * this.scale * -1 + this.offsetY;
      ctx.fillStyle = this.getColor(card.id); // Color based on the card ID
      ctx.fillRect(x, y, this.rectWidth, this.rectHeight); // Draw rectangle with shadow
    });
  }

  getColor(id: number): string {
    // Example colors based on the card ID
    /*const colors = [
      ColorFactory.getColorGreen(),
      ColorFactory.getColorRed(),
      ColorFactory.getColorOrange(),
      ColorFactory.getColorBlue(),
      ColorFactory.getColorYellow(),
      ColorFactory.getColorLightGreen(),
      ColorFactory.getColorLightBlue(),
      ColorFactory.getColorLightYellow(),
      ColorFactory.getColorLightRed(),
      ColorFactory.getColorRed(),
      ColorFactory.getColorOrange(),
      ColorFactory.getColorBlue(),
      ColorFactory.getColorYellow(),
      ColorFactory.getColorGreen(),
    ]; // Red, Green, Blue, Yellow
    return colors[id % colors.length];*/
    return ColorFactory.getColorForCard(id);
  }
}
